"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var ramda_1 = require("ramda");
var ObjFromListWith_1 = require("../../utils/ObjFromListWith");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var reducers = {
    downloadAssetsById: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_DOWNLOAD_ASSET] = function (state, action) {
            var _a;
            return __assign(__assign({}, state), (_a = {}, _a[action.payload.assetId] = action.payload, _a));
        },
        _a[constants_1.SET_ALL_DOWNLOAD_ASSETS] = function (state, action) {
            return ObjFromListWith_1.objFromListWith(ramda_1.prop('assetId'), action.payload);
        },
        _a[constants_1.REMOVE_DOWNLOAD_ASSET] = function (state, action) { return ramda_1.omit([action.payload], state); },
        _a), {}),
    downloadSettings: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SET_DOWNLOAD_SETTINGS] = function (state, action) {
            return action.payload;
        },
        _b[constants_1.SET_WIFI_ONLY] = function (state, action) {
            return __assign(__assign({}, state), { wifiOnly: action.payload });
        },
        _b), {}),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map